// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__RToOc","item-title":"Item_item-title__2m9kF","item-content":"Item_item-content__2A2Rm"};